<template>
  <v-container>
    <div id="swagger-ui"></div>
  </v-container>
</template>

<script>
import SwaggerUI from 'swagger-ui'
import 'swagger-ui/dist/swagger-ui.css'

export default {
  mounted () {
    SwaggerUI({
      url: this.$server + this.$directory + '/docs.json',
      dom_id: '#swagger-ui'
    })
  }
}
</script>

<style>
  .swagger-ui .info {
    display: none;
  }
</style>
